import styled from 'styled-components'

export const Container = styled.div`
  background-color: var(--Grey300);
  display: flex;
  align-items: center;
  background-size: cover;
  width: 100%;
  height: 95vh;
  @media screen and (min-width: 600px) {
    height: 100vh;
  }
`
export const MainDiv = styled.div`
  display: flex;
  margin: auto;
  width: 900px;
  min-height: 540px;
  @media (max-width: 600px) {
    width: 100vw;
    flex-direction: column;
    // margin-right: 16px;
  }
`
export const LeftDiv = styled.div`
  background-color: var(--FjordDark300);
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    display: none;
  }
`
export const RightDiv = styled.div`
  width: 50%;
  padding: 48px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    width: 100%;
    padding: 16px;
  }
`
export const IconHolder = styled.div``
export const LogoHolder = styled.div`
  text-align: center;
  margin-bottom: 80px;
`
export const LoginHeading = styled.div`
  font-size: 20px;
  font-weight: bold;
  line-height: 1.2;
  text-align: left;
  color: var(--Text700);
  margin-bottom: 16px;
`
export const LoginButton = styled.button`
  outline: none;
  border: none;
  width: 100%;
  padding: 14px;
  align-items: center;
  cursor: pointer;
  border-radius: 4px;
  background-color: var(--Azure500);
  font-size: 14px;
  font-weight: bold;
  line-height: 1.43;
  text-align: left;
  color: rgba(255, 255, 255, 0.98);
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 16px;
  opacity: ${({ disabled }) => (disabled ? 0.3 : 1)};
`
export const ContactUsDiv = styled.div`
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.35;
  color: var(--Text500);
  margin-top: 16px;
`
export const ContactUsButton = styled.a`
  margin-left: 4px;
  text-decoration: None;
  color: var(--Azure500);
`

export const SetupHeading = styled(LoginHeading)`
  font-size: 16px;
`

export const InputContainer = styled.div`
  margin-bottom: 16px;
`

export const LangOptionsContainer = styled.div`
  margin-top: 8px;
`
export const LoginSignupDiv = styled.div`
  display: flex;
  text-align: center;
  border: 2px solid black;
  border-radius: 4px;
`
export const Signup = styled.div`
  flex: 1;
  border-right: 1px solid black;
  background-color: ${({ type }) =>
    type === 'signup' ? 'var(--Azure500)' : 'white'};
  color: ${({ type }) => (type === 'signup' ? 'white' : 'black')};
  padding: 6px;
`
export const LoginDiv = styled.div`
  flex: 1;
  background-color: ${({ type }) =>
    type === 'login' ? 'var(--Azure500)' : 'white'};
  color: ${({ type }) => (type === 'login' ? 'white' : 'black')};
  padding: 6px;
`

export const FrogetPasswordLabel = styled.div`
  font-size: 16px;
  font-weight: normal;
  line-height: 1.2;
  text-align: left;
  color: var(--Text700);
  margin-bottom: 16px;
`
export const ResendTryAgainButton = styled.button`
  color: var(--Azure500);
  font-size: 14px;
  margin-bottom: 100px;
  outline: none;
  border: none;
  background: ${({ isSubmitting }) =>
    isSubmitting ? 'var(--Azure500)' : 'none'};
  cursor: pointer;
`
export const ForgetPasswordDiv = styled.div`
  display: flex;
  color: var(--Azure500);
  justify-content: flex-end;
  font-size: 12px;
  cursor: pointer;
`
export const NoteAfterLanguageSelection = styled.p`
  color: var(--azure-500);
  font-size: 14px;
  display: inline-block;
  cursor: pointer;
`

export const WritersBenefit = styled.p`
  text-align: center;
  margin: 8px auto;
  font-size: 12px;
  color: var(--Text500);

  & a {
    color: var(--Azure500);
  }
`
export const DoB = styled.input`
  width: 100%;
  border-radius: 4px;
  border: none;
  background-color: var(--Grey300);
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  color: var(--Text700);
  cursor: pointer;
`
export const DateOfBirth = styled.div`
  width: 100%;
  margin-top: 16px;
  border-radius: 4px;
  border: solid 1px var(--Grey900);
  background-color: var(--Grey300);
  padding: 4px 16px 14px 16px;
  background-color: var(--Grey300);
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  color: var(--Text700);
  cursor: pointer;

  label {
    font-size: 12px;
    color: var(--Text300);
    line-height: 1.33;
  }
`

export const CautionNote = styled.div`
  font-size: 12px;
  color: var(--Text300);
  line-height: 1.33;
`
